module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "content-class": "qr-code"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('div', {
    staticClass: "qr-code__wrapper"
  }, [_c('div', {
    staticClass: "qr-code__title py-5"
  }, [_c('div', {
    staticClass: "w-100 d-flex justify-center"
  }, [_c('router-link', {
    staticClass: "mw-145",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/nav_logo_white.png'),
      "width": "145px"
    }
  })])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "absolute ma-0 color-white btn-close",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_c('v-icon', {
    staticClass: "font-size-34"
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "qr-code__content"
  }, [_c('div', {
    staticClass: "qr-code__content--title"
  }, [_vm._v("\n        " + _vm._s(_vm.typeQR === _vm.qrCodeTypeList.IOS ?
    "Download iOS app" :
    "Download Android app") + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "qr-code__content--img"
  }, [(_vm.typeQR === _vm.qrCodeTypeList.IOS) ? _c('img', {
    attrs: {
      "src": require('@/assets/qr/qrcode_ios.png'),
      "width": "307"
    }
  }) : _c('img', {
    attrs: {
      "src": require('@/assets/qr/qrcode_android.png'),
      "width": "307"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-318beaa8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/qr_code.vue
// module id = 1672
// module chunks = 180